import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'

const fadeOut = keyframes`
  from {
    opacity: 1
  }
  to {
    opacity: 0
  }
`

export const Container = styled(Box)`
  background-color: ${colors.background.secondaryBackground};
  border-radius: 8px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const Form = styled('form')`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const Section = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background-color: ${colors.background.primaryBackground};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`

export const Row = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const Label = styled(Typography)`
  min-width: 150px;
  ${typography.baseline.regularSans}
`

export const SuccessView = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: ${colors.background.primaryBackground};
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-left: 4px solid ${colors.feedback.successDark};
`

export const ErrorMessage = styled(Typography)`
  animation: ${fadeOut} 4s ease-in-out forwards;
  animation-delay: 6s;
  color: ${colors.feedback.errorDark};
  opacity: 1;
  ${typography.baseline.regularSans}
  padding: 12px;
  background-color: ${colors.feedback.errorLight};
  border-radius: 4px;
`

export const SuccessMessage = styled(Typography)`
  animation: ${fadeOut} 4s ease-in-out forwards;
  animation-delay: 6s;
  color: ${colors.feedback.successDark};
  opacity: 1;
  ${typography.baseline.regularSans}
  padding: 12px;
  background-color: ${colors.feedback.successLight};
  border-radius: 4px;
`
